module.exports = __webpack_public_path__ + "static/assets/aff1cf9aa9369d86ea04244d6d3f9a96.png";